module.exports = "<div class=\"time-slider\" #timeSliderContainer></div>"